var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"terms-page",class:{ 'terms-page--dark': _vm.$vuetify.theme.dark }},[_c('v-container',{staticClass:"custom-container"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('TermsAndConditionTabs')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }